import { Component, input } from '@angular/core';

@Component({
  selector: 'app-report-error-list',
  templateUrl: './report-error-list.component.html',
  styleUrls: ['./report-error-list.component.scss'],
  standalone: false,
})
export class ReportErrorListComponent {
  readonly errors = input<string[]>(undefined);
}
